

















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { TemplateCategoryInterface } from '@/pages/TWMCustomTemplates/types/twm-templates'
import TemplateField from '@/pages/TWMCustomTemplates/TemplateField.vue'


@Component({
    components: {
        TemplateField
    }
})
export default class TemplateCategory extends Vue {
    @Prop() value!: TemplateCategoryInterface
    template = ''

    get templates(): string[] {
        return this.value.list
    }

    addTemplate() {
        if (this.template) {
            this.value.list.push(this.template)
            this.template = ''
            this.handleInput()
        }
    }

    editTemplate(index: number, template: string) {
        this.value.list[index] = template
        this.handleInput()
    }

    deleteTemplate(index: number) {
        this.value.list.splice(index, 1)
        this.handleInput()
    }

    @Emit('input')
    handleInput(): TemplateCategoryInterface {
        return this.value
    }

    @Emit('delete-category')
    deleteCategory(): TemplateCategoryInterface {
        return this.value
    }
}
